import axios from 'axios'
import {ALTERAR_FORMA_PAGAMENRO_PEDIDO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function alterarForomaPagamentoPedido (alteraFormaPagamento) {
  const url = `${URL}/pedido/alterar-forma-pagamento`;
  return dispatch => axios.post(url, alteraFormaPagamento, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_FORMA_PAGAMENRO_PEDIDO,
        payload: response
      })
  );
}
